
webpack.register(
    'blocks/navigation/hamburger-menu/hamburger-menu',
    function() {
        return import('blocks/navigation/hamburger-menu/hamburger-menu');
    },
    true
);